module.exports = __webpack_public_path__ + "static/media/Sliders1.e88668fa.png";